<template>
    <div>
        <el-row>
            <h4>Job Chains for User</h4>
        </el-row>
        <el-row v-for="jobchain in list_of_jobchains">
            <progress-display :job_chain_id="jobchain.id" :extent_id="jobchain.extent_id"/>
        </el-row>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted now.')
            window.axios.get('/progress/list')
                .then(response => {
                    console.log("response.data:")
                    console.log(response.data)
                    this.list_of_jobchains = response.data
                    console.log("list_of_jobchains:")
                    console.log(this.list_of_jobchains)
                })
                .catch(error => {
                    console.log('oops problem getting job chain information')
                })
        },
        data() {
            return {
                list_of_jobchains: []
            }
        },
        methods: {
        }
    }
</script>